// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthModule } from '@auth0/auth0-angular';
import { LINQ_FEATURE_FLAG_CONFIG, LinqFeatureFlagConfig } from '@linq/feature-flag';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { APP_CONFIG, AppConfig } from '@app/core/app-config';
import { APP_INITIALIZER } from '@angular/core';
import { THEME_INITIALIZER } from '@app/core/initializers';
import { LinqHttpInterceptor } from '@app/core/interceptors';
import { linqHttpInterceptor } from '@app/core/interceptors/linq-http.interceptor';
import { ThemeService } from '@app/core/services';
import { AppComponent } from './app/app.component';

// @ts-expect-error Accept HMR
if (module.hot) {
  // @ts-expect-error Accept HMR
  module.hot.accept();
}

// Set tenant id as `alio32`
fetch(`api/config/app-config.json`)
  .then((response) => response.json())
  .then((config: AppConfig) => {
    if (config.production) {
      enableProdMode();
    }

    if (config.production || !config.auth0Subdomain) {
      const host = window.location.hostname.split('.');
      if (host.length >= 2) {
        config.auth0Subdomain = host.slice(0, host.length - 2).join('.');
      }
    }

    // Ensure Auth0 client ID is fetched before bootstrap
    const initializeAuth0 = async () => {
      if (!config.auth0ClientId) {
        try {
          const params = new URLSearchParams({
            product: 'ERP',
            subdomain: config.auth0Subdomain,
          });
          const clientResponse = await fetch(`${config.accountsApiUrl}/clients/home-realm?${params}`, {
            method: 'GET',
          });
          const client = await clientResponse.json();
          config.auth0ClientId = client.clientId;
        } catch (error) {
          console.error('Failed to fetch Auth0 client from home-realm:', error);
        }
      }
    };

    initializeAuth0().then(() => {
      const auth0Providers =
        AuthModule.forRoot({
          domain: config.auth0Domain || '',
          clientId: config.auth0ClientId || '',
          // These three are top-level AuthConfig options and MUST stay out of
          // `authorizationParams`. Only `authorizationParams` is forwarded to
          // /authorize, and it carries an `[key: string]: any` index signature --
          // so nesting them there compiles fine, ships them to Auth0 as junk query
          // params, and leaves the SDK on its defaults (memory cache, no
          // offline_access, no refresh token).
          useRefreshTokens: true,
          useRefreshTokensFallback: false,
          cacheLocation: 'localstorage',
          authorizationParams: {
            redirect_uri: window.location.href,
            audience: config.auth0Audience || '',
            scope: config.auth0Scope || '',
            auth_ctx: JSON.stringify({
              tenant_id: config.tenantId || '',
            }),
          },
        }).providers || [];
      const providers: any[] = [
        // Angular framework providers
        provideAnimations(),

        // HTTP client with functional interceptor
        provideHttpClient(withInterceptors([linqHttpInterceptor])),

        // Auth0 configuration
        ...auth0Providers,

        // App configuration
        {
          provide: APP_CONFIG,
          useValue: config,
        },

        // Feature flags
        {
          provide: LINQ_FEATURE_FLAG_CONFIG,
          deps: [APP_CONFIG],
          useFactory: (appConfig: AppConfig) => {
            const featureFlag: LinqFeatureFlagConfig = {
              clientKey: appConfig.ldClientKey,
            };
            return featureFlag;
          },
        },

        // Theme initializer
        {
          provide: APP_INITIALIZER,
          useFactory: THEME_INITIALIZER,
          deps: [ThemeService],
          multi: true,
        },

        // Services
        CookieService,
      ];

      bootstrapApplication(AppComponent, {
        providers: providers,
      })
        // eslint-disable-next-line no-console
        .catch((err) => console.error(err));
    });
  });
